import loadable from '@loadable/component';

export const HomesandgardensSiteWrapper = loadable(
  () => import(/* webpackChunkName: "homesandgardens-site" */ './HomesandgardensSiteWrapper'),
);
